import {
  useMutation
} from '@tanstack/vue-query'
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query'
import {
  unref
} from 'vue'
import type {
  MaybeRef
} from 'vue'
import type {
  BackendErrorEntity,
  TrackSaleViewBodyDto
} from '.././types'
import { fetchApiInstance } from '../../fetchApiInstance';
import type { ErrorType, BodyType } from '../../fetchApiInstance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const apiTrackSaleView = (
    trackSaleViewBodyDto: MaybeRef<TrackSaleViewBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      trackSaleViewBodyDto = unref(trackSaleViewBodyDto);
      
      return fetchApiInstance<void>(
      {url: `/sale-views`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: trackSaleViewBodyDto
    },
      options);
    }
  


export const getApiTrackSaleViewMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiTrackSaleView>>, TError,{data: BodyType<TrackSaleViewBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiTrackSaleView>>, TError,{data: BodyType<TrackSaleViewBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiTrackSaleView>>, {data: BodyType<TrackSaleViewBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiTrackSaleView(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiTrackSaleViewMutationResult = NonNullable<Awaited<ReturnType<typeof apiTrackSaleView>>>
    export type ApiTrackSaleViewMutationBody = BodyType<TrackSaleViewBodyDto>
    export type ApiTrackSaleViewMutationError = ErrorType<BackendErrorEntity>

    export const useApiTrackSaleView = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiTrackSaleView>>, TError,{data: BodyType<TrackSaleViewBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiTrackSaleView>>,
        TError,
        {data: BodyType<TrackSaleViewBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiTrackSaleViewMutationOptions(options);

      return useMutation(mutationOptions);
    }
    